import type { FaireProductEntity } from "../../entity_types/product";

export const p_8hkrentsar: FaireProductEntity = {
  token: "p_8hkrentsar",
  type: "product",
  name: "Wool Cloud Neckscarf",
  brandToken: "b_54be1bc9",
  brandName: "SCARFSHOP",
  imageUrl:
    "https://cdn.faire.com/fastly/4f7bd36151a1b0707e26a131b71bdc8e84aa1bccc2991c85892c7950c08fa80a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d59c528287305ce6ca55fe62bf4300e3937ba41776fd82f80df61d32e996b19.jpeg",
    "https://cdn.faire.com/fastly/2141bcaa63a1a405d2292a9e8566484eda03b067e1d993766d48831f7498e4a7.jpeg",
    "https://cdn.faire.com/fastly/a12f71c156614d8e7849ba1425aed572ebf1322c0bbdd558f3ef84563d427e04.jpeg",
    "https://cdn.faire.com/fastly/e115d4670a529e874917296fddb2c6a60570254f0a215df9e62bb31f9c1364a5.jpeg",
    "https://cdn.faire.com/fastly/c658e9520eb3938cea1b7a581468d3443d093a28b87d3ab98f480f7a5fb2814f.jpeg",
    "https://cdn.faire.com/fastly/61541c46bb12ce808d75cf9fafb930807f2d8a15b2881b0dee84abeb4478b6eb.jpeg",
    "https://cdn.faire.com/fastly/dc12291179d4f47169521956d1ee12487e9628f341468d7ec4bc2c9198060936.jpeg",
    "https://cdn.faire.com/fastly/326a580596102176ae876bdd5f6d531b529c878c2ab9b2c706a407fe47921f4e.jpeg",
    "https://cdn.faire.com/fastly/fe1a847e82b28824135b53a46c9b9282ff8f292ba834396d33f3afa5ea68878b.jpeg",
    "https://cdn.faire.com/fastly/6c68e787bb38f1c8f1b2052416b32d318255ddd20b291abfc6c5783c55314293.jpeg",
  ],
  priceDollars: 26,
  description:
    '*Please note that while we maintain a small amount of stock, most of our products are made to order and may take up to 2 weeks to ship, although most ship in just a few days. Please contact us if you have a time sensitive order.\n\nA very soft, drapey knit fabric that ranges from slightly transparent to opaque which gives a textural appearance, like a cloud.\n\n100% hand dyed wool knit with raw edges\nFour sizes to choose from (this listing is for the NECKSCARF size):\nLARGE WOOL cloud: 48" x 72": $215\nMEDIUM WOOL cloud: 28” x 72”: $115\nBABY WOOL cloud: 24" x 60": $75\nNECKSCARF WOOL cloud 25” x 25”, $50\n(dimensions are approximate - scarf is very stretchy)\nAvailable in 48 colors.',
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:49.036Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
